import * as React from 'react';

export interface CollapseButtonProps {
  onClick: () => void;
}

const CollapseButton = ({ onClick }: CollapseButtonProps): JSX.Element => (
  <button type="button" className="collapse-btn" data-collapse="toggle" onClick={onClick}>
    <div className="collapse-btn__icon">
      <svg className="u-icon-i-menu-arrow-dims">
        <use xlinkHref="#i-menu-arrow" />
      </svg>
    </div>
    <span className="collapse-btn__label" data-collapse="toggle-label">Collapse Menu</span>
  </button>
);

export default CollapseButton;
